import { render, staticRenderFns } from "./ed-subject-builder-rules-list.component.vue?vue&type=template&id=9c00bf64&scoped=true&"
import script from "./ed-subject-builder-rules-list.component.ts?vue&type=script&lang=ts&"
export * from "./ed-subject-builder-rules-list.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-subject-builder-rules-list.component.scss?vue&type=style&index=0&id=9c00bf64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c00bf64",
  null
  
)

export default component.exports